import axios from "axios";
import { API } from "@/apiConfig";

const DEFAULTS = { cc_db_surcharge: 0, min_credit_debit_amount: 0 };

// Which card terminal this register uses (ModeskPay/ModeskP1). Returns the terminal's settings
// plus `driver` ("dejavoo") which picks the backend route prefix (/dejavoo/*).
export async function fetchTerminalSettings(stationId) {
  const sid = stationId || "default";
  const { data: dj } = await axios.get(`${API}/settings/dejavoo?station_id=${sid}`);
  return { ...DEFAULTS, ...dj, driver: "dejavoo", ip_address: dj.mode === "cloud" ? "cloud" : (dj.local_ip || "") };
}

export const terminalRoute = () => "dejavoo";
export const terminalLabel = () => "ModeskP1";
